import api from "../api";

export default {
  namespaced: true,
  state: {
    item: {},
  },
  actions: {
    list(store, params) {
      return new Promise((resolve, reject) => {
        api.post('documents/list/' + params.page, params).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error.response);
        });
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/documents.js